import PropTypes from 'prop-types';
import React from 'react';
import { Transition } from 'react-spring';

import useBodyScroll from '../../hooks/useBodyScroll';
import useSharedRef from '../../hooks/useSharedRef';
import CloseButton from './CloseButton';
import StyledOverlay from './styled';

const Overlay = ({ children, open, onRequestClose }) => {
  useBodyScroll(!open);

  const { refs } = useSharedRef();
  const { hub: hubRef } = refs;

  let bottom = 0;
  if (process.browser) {
    bottom = `${
      hubRef
        ? window.innerHeight - hubRef.getBoundingClientRect().bottom
        : window.innerHeight
    }px`;
  }

  return (
    <Transition
      native
      items={open}
      from={{ bottom }}
      enter={{ bottom: '0px' }}
      leave={{ bottom }}
    >
      {(toggle) => (props) =>
        toggle && (
          <StyledOverlay style={props}>
            {children}
            <CloseButton onClick={onRequestClose} />
          </StyledOverlay>
        )}
    </Transition>
  );
};

Overlay.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

Overlay.defaultProps = {
  open: false,
};

export default Overlay;
